import { isEmpty, isNil, sortBy } from "lodash";
import { findFieldByPath } from "../../data-fields";
import { fieldTitle } from "./zones";

const ARRAY_TOKEN = "[N]";
const MAX_DEPTH = 12;
const MAX_PATHS = 4000;
const SAMPLE_MAX_LENGTH = 60;
const SKIPPED_KEYS = new Set(["logo", "base64", "fileContent"]);

const isPlainObject = (value) =>
  !isNil(value) && typeof value === "object" && !Array.isArray(value);

const sampleOf = (value) => {
  if (isNil(value)) return null;
  const text = String(value);
  return text.length > SAMPLE_MAX_LENGTH
    ? `${text.slice(0, SAMPLE_MAX_LENGTH)}…`
    : text;
};

const typeOf = (value) => {
  if (isNil(value)) return "null";
  if (Array.isArray(value)) return "array";
  return typeof value;
};

export const flattenPayload = (payload) => {
  const rows = [];
  const walk = (value, path, depth) => {
    if (rows.length >= MAX_PATHS || depth > MAX_DEPTH) return;
    if (Array.isArray(value)) {
      rows.push({ path, type: "array", sample: null });
      const [first] = value;
      if (isPlainObject(first) || Array.isArray(first)) {
        walk(first, `${path}${ARRAY_TOKEN}`, depth + 1);
        return;
      }
      if (first !== undefined)
        rows.push({
          path: `${path}${ARRAY_TOKEN}`,
          type: typeOf(first),
          sample: sampleOf(first),
        });
      return;
    }
    if (isPlainObject(value)) {
      for (const key of Object.keys(value)) {
        if (SKIPPED_KEYS.has(key)) continue;
        walk(value[key], isEmpty(path) ? key : `${path}.${key}`, depth + 1);
      }
      return;
    }
    if (!isEmpty(path))
      rows.push({ path, type: typeOf(value), sample: sampleOf(value) });
  };
  walk(payload, "", 0);
  return rows;
};

const labelOf = (path) => {
  const field = findFieldByPath(path);
  return isNil(field) || !isNil(field.source) ? path : fieldTitle(field);
};

export const pathOptions = ({ payload, schemaPaths }) =>
  sortBy(
    (isEmpty(schemaPaths) ? flattenPayload(payload) : schemaPaths).map(
      ({ path, type, sample }) => ({
        value: path,
        label: labelOf(path),
        type,
        sample,
      }),
    ),
    (option) => (option.label === option.value ? 1 : 0),
  );
